/** Godot's `VisualInstance3D.layers` mask, and the masks that decals, cameras and reflection probes test it with. */
/** `VisualInstance3D::layers`' default: layer 1 only (`scene/3d/visual_instance_3d.h:42`). */
export const GODOT_DEFAULT_VISUAL_LAYERS = 1;
/**
 * The 20 layers the editor shows, the default of every mask a node tests layers with: Camera3D's
 * `cull_mask` (`camera_3d.h:83`), Decal's (`decal.h:54`) and ReflectionProbe's two
 * (`reflection_probe.h:65-66`).
 */
export const GODOT_EDITOR_LAYERS_MASK = (1 << 20) - 1;
/**
 * The layer Godot's editor draws every gizmo on (`node_3d_editor_gizmos.cpp:222`), layer 27 of 1 to
 * 32 (`node_3d_editor_plugin.h:187-190`), past the 20 every scene mask defaults to.
 */
export const GODOT_EDITOR_GIZMO_LAYERS = 1 << 26;
//# sourceMappingURL=visualLayers.js.map